import React, { Component } from 'react'

export default class Error extends Component {

    render() {
        return (
            <div style={{
                backgroundColor: 'red',
                position: 'fixed',
                justifyContent: 'center',
                alignItems: 'center',
                display: 'flex',
                left: '50%',
                top: 2,
                right: 'auto',
                marginRight: '-50%',
                height: 30,
                borderRadius: 8,
                zIndex: 100000000,
                flexDirection: 'row',
                transform: 'translate(-50%)'
            }}>
                <span style={{marginLeft: 10, fontSize: 20, color: '#fff', fontWeight: 'bold', marginRight: 10}}>{this.props.error}</span>
                <img src={require('../images/close.png')} style={{ cursor: 'pointer', width: 25, height: 25}} onClick={this.props.clearError}/>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/Error.js